import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import LinearProgress, {
  LinearProgressProps,
} from "@material-ui/core/LinearProgress";

const progressStyles = (theme: Theme) =>
  createStyles({
    bar: {
      height: 10,
    },
    rootCompact: {
      height: 4,
      borderRadius: 2,
    },
    barCompact: {
      height: 4,
    },
    colorSecondary: {
      backgroundColor: lighten(theme.palette.secondary.main, 0.7),
    },
    barColorSecondary: {
      backgroundColor: theme.palette.secondary.main,
    },
    colorPrimary: {
      backgroundColor: lighten(theme.palette.primary.main, 0.7),
    },
    barColorPrimary: {
      backgroundColor: theme.palette.primary.main,
    },
  });

export interface UiProgressProps extends LinearProgressProps {
  compact?: boolean;
  classes?: Record<string, string>;
}

const UiProgress = ({
  classes,
  compact = false,
  ...props
}: UiProgressProps) => (
  <LinearProgress
    {...props}
    classes={{
      bar: compact ? classes!.barCompact : classes!.bar,
      root: compact ? classes!.rootCompact : undefined,
      colorSecondary: classes!.colorSecondary,
      barColorSecondary: classes!.barColorSecondary,
      colorPrimary: classes!.colorPrimary,
      barColorPrimary: classes!.barColorPrimary,
    }}
  />
);

export default withStyles(progressStyles)(UiProgress);
